import { sendApiAIRequest } from "../../api/api";

// AI WAVE 展場配方卡名單：資料庫在 bas-backend（見 aiWaveLead.model.js），
// 走 sendApiAIRequest（REACT_APP_AI_AGENT_API_URL），跟 RecommendedPromptsManagement 同一支後端。
const BASE = "/api/ai-wave/leads";

const unwrap = (res) => {
  if (!res || res.status >= 400) {
    const msg =
      res?.data?.msg ||
      res?.data?.message ||
      (res?.status === 403 ? "僅限系統管理員查看" : "請求失敗");
    throw new Error(typeof msg === "string" ? msg : JSON.stringify(msg));
  }

  const body = res.data;
  if (!body || typeof body !== "object") {
    return null;
  }

  if (body.error) {
    const msg = body.msg || body.message || "請求失敗";
    throw new Error(typeof msg === "string" ? msg : JSON.stringify(msg));
  }

  return body.data !== undefined ? body.data : body;
};

export const fetchAiWaveLeadsList = async ({ search = "", page = 1, limit = 20 } = {}) => {
  const params = new URLSearchParams();
  if (search.trim()) {
    params.set("search", search.trim());
  }
  params.set("page", String(page));
  params.set("limit", String(limit));
  const res = await sendApiAIRequest("GET", `${BASE}?${params.toString()}`);
  return unwrap(res);
};
